import React, { useState } from "react";
import styled from "styled-components";
import InputBox from "../elements/inputBox";
import Loader from "../Loader/Loader";

const CenteredContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;
`;

const LoginContainer = styled.div`
	max-width: 300px;
	width: 100%;
	padding: 20px;
	border: 1px solid #ccc;
	border-radius: 5px;
	box-sizing: border-box;
	background-color: #ffffff;
`;

const LoginForm = styled.form`
	display: flex;
	flex-direction: column;
`;

const Button = styled.button`
	padding: 10px;
	border: none;
	border-radius: 5px;
	cursor: pointer;
	background: linear-gradient(180deg, #ff9250 0%, #f37021 100%);
	box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
	color: #ffffff;
`;

const NbfcLogin = ({
	handleChange,
	submitNbfcLoginRequest,
	fields,
	loading,
	errors,
}) => {

	return (
		<CenteredContainer>
			<LoginContainer>
				<h2 style={{ textAlign: "center", marginBottom: "20px" }}>
					NBFC Login
				</h2>
				<LoginForm>
					<InputBox label="Email" type="email" name="email" id="email" handleChange={handleChange} value={fields?.email} errors={errors} />
					<InputBox
						label="Password"
						type="password"
						name="password"
						id="password"
						handleChange={handleChange}
						value={fields?.password}
						errors={errors}
					/>
					{loading ? <Loader /> : <Button type="button" onClick={submitNbfcLoginRequest}>
						Login
					</Button>}
				</LoginForm>
			</LoginContainer>
		</CenteredContainer>
	);
};

export default NbfcLogin;
